import React from 'react';
import isEmpty from 'lodash/isEmpty';
import { isActiveMenu } from '../utils';
import * as S from './styles';
const TextSubMenu = ({ item, clickCallback }) => {
    const { href, title, callback } = item;
    const mainHref = isEmpty(href) ? undefined : href;
    const handleClick = (e) => {
        e.stopPropagation();
        if (callback)
            callback();
        clickCallback();
    };
    const handleKeyDown = (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            if (callback)
                callback();
            clickCallback();
        }
    };
    return (React.createElement(S.CustomLink, { role: "menuitem", href: mainHref, underline: "none", "$isActive": isActiveMenu(href), onClick: handleClick, onKeyDown: handleKeyDown }, title));
};
export default TextSubMenu;
//# sourceMappingURL=index.js.map